
  import {Component, Vue} from "vue-property-decorator";
  import {isMobileOnly} from "mobile-device-detect";
  import AdditionalBtns from "@/modules/Car/components/carInfoControls/AdditionalBtns.vue";

@Component({
  components: {AdditionalBtns}
})
export default class AdditionalBtnsWrapper extends Vue {
  isMobileOnly = false;
  visibleDropdown = false;

  created() {
    this.isMobileOnly = isMobileOnly;
  }

}
